import { indexBy } from '../utils/algorithms'

const timeIntervalInMilliseconds = 12 * 60 * 60 * 1000 // 12h

function canFetchNewData(state, timeIntervalToFetch) {
  if (!state?.data) return true
  if (!state?.lastSyncDate) return true
  if (Date.now() - state.lastSyncDate >= timeIntervalToFetch) return true
  return false
}

function hasPreconditionsToFetch(rootState, state) {
  if (
    rootState.auth?.user?.employeeCode === undefined ||
    rootState.auth.user.employeeCode === null
  )
    return false
  if (state.loading) return false
  return true
}

const jobTitles = {
  Vendedor: 'salesman',
  Coordenador: 'coordinator',
  Gerente: 'manager',
  Empresa: 'company',
}

export const state = () => ({
  data: null,
  loading: false,
  lastSyncDate: null,
})

export const getters = {
  indexes: state =>
    indexBy(state.data, {
      key: 'jobTitle',
      formatKeyValue: v => jobTitles[v] ?? '__unknown__',
    }),
}

export const mutations = {
  UPDATE_ROOT: (state, payload) => Object.assign(state, payload),
}

export const actions = {
  async fetchHierarchy(
    { state, rootState, commit },
    { forceUpdate } = { forceUpdate: false }
  ) {
    if (!hasPreconditionsToFetch(rootState, state)) return
    if (!canFetchNewData(state, timeIntervalInMilliseconds) && !forceUpdate)
      return
    commit('UPDATE_ROOT', { loading: true })

    const savedState = (await this.$localforage.getItem('hierarchy'))?.hierarchy
    if (
      (!forceUpdate &&
        savedState &&
        Date.now() - savedState.lastSyncDate < timeIntervalInMilliseconds) ||
      !window.navigator.onLine
    ) {
      commit('UPDATE_ROOT', {
        ...savedState,
        loading: false,
      })
      return
    }
    try {
      const { data } = await this.$axios.get(`/v3/app/employee/hierarchy`)
      commit('UPDATE_ROOT', {
        data,
        lastSyncDate: Date.now(),
      })
    } catch (error) {
      console.error('Error fetching user hierarchy', error)
      commit('UPDATE_ROOT', { lastSyncDate: null })
      window.$nuxt.$notify.error({
        message: 'Erro ao buscar hierarquia',
      })
    } finally {
      commit('UPDATE_ROOT', { loading: false })
    }
  },
}
